import React from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { Controller } from "react-hook-form";
import PropTypes from "prop-types";

const ControlledAutocomplete = ({
  options = [],
  renderInput,
  getOptionLabel,
  control,
  defaultValue,
  name,
  renderOption,
  rules,
}) => {
  return (
    <Controller
      render={({ onChange, ...props }) => (
        <Autocomplete
          options={options}
          getOptionLabel={getOptionLabel}
          renderOption={renderOption}
          renderInput={renderInput}
          onChange={(e, data) => onChange(data)}
          {...props}
        />
      )}
      onChange={([, data]) => data}
      defaultValue={defaultValue}
      name={name}
      control={control}
      rules={rules}
    />
  );
};

ControlledAutocomplete.defaultProps = {
  defaultValue: null,
};

ControlledAutocomplete.propTypes = {
  options: PropTypes.array,
  renderInput: PropTypes.any,
  getOptionLabel: PropTypes.func,
  control: PropTypes.any,
  defaultValue: PropTypes.object,
  name: PropTypes.string,
  renderOption: PropTypes.func,
  rules: PropTypes.object,
};

export { ControlledAutocomplete };
